import React, {useState,useEffect} from 'react'

export default function Feature() {
   
   const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

   const [width, setWidth] = useState(getWidth());

   useEffect(() => {
      setTimeout(function () {
         document.querySelector(".loader-wrapper").style = "display: none";
      }, 2000);

      // timeoutId for debounce mechanism
      let timeoutId = null;
      const resizeListener = () => {
         // prevent execution of previous setTimeout
         clearTimeout(timeoutId);
         // change width from the state object after 150 milliseconds
         timeoutId = setTimeout(() => setWidth(getWidth()), 150);
      };
      // set resize listener
      window.addEventListener('resize', resizeListener);
      
      // clean up function
      return () => {
         // remove resize listener
         window.removeEventListener('resize', resizeListener);
      }
   }, [])

   const fixTovoBug = width > 1199 ? {} : {
      marginTop: '-24px'
   }

   return (
      <section id="feature" className="feature">
         <div className="feature-decor">
            <div className="feature-circle1"><img src="assets/images/feature2.png" alt="" /></div>
         </div>
         <div className="container">
            <div className="row">
               <div className="feature-phone">
                  <img src="assets/images/222.png" className="img-fluid" alt="" />
               </div>
               <div className="offset-lg-4 col-lg-8">
                  <div className="row">
                     <div className="col-sm-12 mrgn-md-top">
                        <h2 className="title">features of<span> DropSpin</span></h2>
                     </div>
                     <div className="col-12 col-md-6">
                        <ul className="feature-style">
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/1.png" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>user friendly</h3>
                              </div>
                              <div>
                                 <p>A tool designed for groups to test changes on the fly, keeping rehearsal running smooth.</p>
                              </div>
                           </li>
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/3.png" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>high performance</h3>
                              </div>
                              <div>
                                 <p>Every sample in dropspin is tempo-perfect. We are proud to present the most tempo-accurate metronome on the market.<br /></p>
                              </div>
                           </li>
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/5.png" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>Custom Settings</h3>
                              </div>
                              <div>
                                 <p>Every part of the rehearsal process is fully customizable. Sync settings across your organization for consistent results.</p>
                              </div>
                           </li>
                        </ul>
                     </div>
                     <div className="col-12 col-md-6 sm-m-top">
                        <ul className="feature-style">
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/2.png" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>Loop Segments</h3>
                              </div>
                              <div>
                                 <p>Dropspin offers educators tons of flexibility, however they run their rehearsals.<br /><br /></p>
                              </div>
                           </li>
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/4.png" alt="icon" />
                              </div>
                              <div className="feature-subtitle" style = {fixTovoBug}>
                                 <h3>Modeled from the best</h3>
                              </div>
                              <div>
                                 <p>Specially designed for the rehearsal process of the best DCI/WGI groups in the world.<br /></p>
                              </div>
                           </li>
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/6.png" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>DB-90 Samples</h3>
                              </div>
                              <div>
                                 <p>Sampled directly from the doctor himself--rehearse with the same sounds you know and love.</p>
                              </div>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}


// WEBPACK FOOTER //
// ./src/components/feature.js